import React, { useEffect, useState } from "react";
import BlogDetails from "../components/blogdetails";
import { MEDIUM_API_URL } from "../config/constants";
import BlogCard from "../components/blogcard";
const BlogPage = () => {
  const [details, setDetails] = useState({});

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await fetch(MEDIUM_API_URL);
        const { items } = await response.json();
        setDetails(items);
      } catch (error) {
        console.log("Error fetching URL\n");
      }
    };
    fetchDetails().catch((err) => console.log(err));
  }, []);

  return (
    <>
      <div id="blogs">
        <h2 className="md:text-5xl text-center font-bold text-white text-4xl pt-10">
          🍃 My Blogs
        </h2>
        <section className="container mt-20 mx-auto max-w-screen-2xl pb-10 px-4 sm:px-8 bg-[#090E34]">
          <BlogDetails />
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-y-4 md:gap-y-6 place-items-center p-10 md:p-16">
            {details.length &&
              details.map(({ title, pubDate, link }) => {
                return (
                  <BlogCard
                    title={title}
                    link={link}
                    pubDate={pubDate}
                    key={title}
                  />
                );
              })}
          </div>
        </section>
      </div>
    </>
  );
};

export default BlogPage;
